// @ts-nocheck
/**
 * normalizeSvgXmlForNative — strip SVG namespace prefixes so react-native-svg SvgXml
 * can resolve tags (it looks up exact names like `path`, not `ns0:path`).
 *
 * Browser <img>/data-URI paint handles prefixed tags; native does not.
 * Safe to run on already-clean markup (no-op when there are no prefixes).
 */

const OPEN_OR_CLOSE_TAG_RE = /<\/?([A-Za-z_][\w.-]*):([A-Za-z_][\w.-]*)(\s|>|\/)/g;
const XMLNS_PREFIX_RE = /\sxmlns:[A-Za-z_][\w.-]*\s*=\s*(["'])[^"']*\1/gi;

/**
 * Rewrite namespaced SVG element tags to local names and drop xmlns:* declarations.
 * Example: `<ns0:path xmlns:ns0="http://www.w3.org/2000/svg" …>` → `<path …>`
 */
export function normalizeSvgXmlForNative(xml: string): string {
  if (!xml.includes('<') || !xml.includes(':')) {
    return xml;
  }

  let result = xml.replace(OPEN_OR_CLOSE_TAG_RE, (_full, _prefix: string, local: string, trail: string) => {
    const isClose = _full.startsWith('</');
    return `${isClose ? '</' : '<'}${local}${trail}`;
  });

  result = result.replace(XMLNS_PREFIX_RE, '');
  return result;
}
